import { SiteWithLocation } from "@hydrologiq/gql-experience/graphql"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface Sitestate {
  value: SiteWithLocation[] | undefined
}

const EMPTY_SITES: SiteWithLocation[] = []
const initialState = { value: undefined } satisfies Sitestate as Sitestate

export const siteslice = createSlice({
  name: "sites",
  initialState,
  selectors: {
    getSites: (state): SiteWithLocation[] => {
      return state.value || EMPTY_SITES
    },
    getSite: (state, payload?: string): SiteWithLocation | undefined => {
      return state.value?.find((s) => s.id === payload)
    },
  },
  reducers: {
    setSites: (state, action: PayloadAction<SiteWithLocation[]>) => {
      state.value = action.payload
    },
    setSite: (state, action: PayloadAction<SiteWithLocation>) => {
      if (state.value?.find((s) => s.id === action.payload.id)) {
        state.value = state.value?.map((s) => (s.id === action.payload.id ? action.payload : s))
      } else {
        state.value = [action.payload, ...(state.value || [])]
      }
    },
  },
})

export const { setSites, setSite } = siteslice.actions
export const { getSites, getSite } = siteslice.selectors
export default siteslice.reducer
